import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg width="469" height="277" viewBox="0 0 469 277" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M0 0h469v277H0z" />
      <path fill="#D0DCEC" d="M62 234.187h342.72V41.297H62z" />
      <path fill="#FAFAFA" d="M62 226.196h342.72V33.306H62z" />
      <path stroke="#50A1DA" strokeWidth="5" d="M73.506 66.26h319.708" />
      <path fill="#1251A0" d="M208.278 169.962h50.165v-15.149h-50.165z" />
      <path
        fill="#E5E5E5"
        d="M162.855 121.304h141.01v-15.149h-141.01zM162.855 144.027h141.01V128.88h-141.01z"
      />
      <path fill="#CCC" d="M208.278 166.75h50.165v-15.148h-50.165z" />
      <path
        fill="#1251A0"
        d="M265.498 171.807l-6.44 2.585a.292.292 0 0 0-.149.15l-2.583 6.442c-.075.225-.412.225-.487 0l-7.75-17.043a.248.248 0 0 1 .338-.337l17.07 7.716c.225.112.188.412 0 .487"
      />
      <path
        fill="#50A1DA"
        d="M175.528 140.278l-1.504-2.182-1.479 2.182-1.905-1.405 1.654-1.957-2.356-.476.702-2.333 2.306.878-.125-2.358h2.381l-.25 2.408 2.456-.928.652 2.333-2.406.476 1.754 1.957zM184.127 140.278l-1.504-2.182-1.479 2.182-1.905-1.405 1.654-1.957-2.356-.476.702-2.333 2.306.878-.125-2.358h2.381l-.25 2.408 2.456-.928.652 2.333-2.406.476 1.754 1.957zM192.726 140.278l-1.504-2.182-1.479 2.182-1.905-1.405 1.654-1.957-2.356-.476.702-2.333 2.306.878-.125-2.358h2.381l-.25 2.408 2.456-.928.652 2.333-2.407.476 1.755 1.957zM201.325 140.278l-1.504-2.182-1.479 2.182-1.905-1.405 1.654-1.957-2.356-.476.702-2.333 2.306.878-.125-2.358h2.381l-.25 2.408 2.456-.928.652 2.333-2.406.476 1.754 1.957zM175.528 117.555l-1.504-2.182-1.479 2.182-1.905-1.405 1.654-1.957-2.356-.476.702-2.333 2.306.878-.125-2.358h2.381l-.25 2.408 2.456-.928.652 2.333-2.406.476 1.754 1.957zM184.127 117.555l-1.504-2.182-1.479 2.182-1.905-1.405 1.654-1.957-2.356-.476.702-2.333 2.306.878-.125-2.358h2.381l-.25 2.408 2.456-.928.652 2.333-2.406.476 1.754 1.957zM192.726 117.555l-1.504-2.182-1.479 2.182-1.905-1.405 1.654-1.957-2.356-.476.702-2.333 2.306.878-.125-2.358h2.381l-.25 2.408 2.456-.928.652 2.333-2.407.476 1.755 1.957zM201.325 117.555l-1.504-2.182-1.479 2.182-1.905-1.405 1.654-1.957-2.356-.476.702-2.333 2.306.878-.125-2.358h2.381l-.25 2.408 2.456-.928.652 2.333-2.406.476 1.754 1.957zM209.924 117.555l-1.504-2.182-1.479 2.182-1.905-1.405 1.654-1.957-2.356-.476.702-2.333 2.306.878-.125-2.358h2.381l-.25 2.408 2.456-.928.652 2.333-2.406.476 1.754 1.957zM218.523 117.555l-1.504-2.182-1.479 2.182-1.905-1.405 1.654-1.957-2.356-.476.702-2.333 2.306.878-.125-2.358h2.381l-.25 2.408 2.456-.928.652 2.333-2.407.476 1.755 1.957z"
      />
      <path
        fill="#1251A0"
        d="M123.394 59.688h1.149v-4.89h-1.15v4.89zm-3.621 1.753h8.39v-8.396h-8.39v8.396z"
      />
      <path fill="#15539F" d="M119.773 61.44h8.39v-8.395h-8.39z" />
      <path
        fill="#1251A0"
        d="M113.534 54.798v4.89h1.149v-1.587h2.115v-1.15h-2.115v-1.003h2.55v-1.15h-3.7zm-2.403 6.643h8.39v-8.395h-8.39v8.395z"
      />
      <path fill="#15539F" d="M111.13 61.44h8.391v-8.395h-8.39z" />
      <path
        fill="#7BB934"
        d="M106.11 59.688h1.149v-4.89h-1.15v4.89zm-3.621 1.753h8.39v-8.396h-8.39v8.396z"
      />
      <path fill="#7BB835" d="M102.489 61.44h8.39v-8.395h-8.39z" />
      <path
        fill="#7BB934"
        d="M99.096 57.243c0 .716-.58 1.296-1.295 1.296h-.812v-2.591h.812c.715 0 1.295.58 1.295 1.295zm-3.257-2.445v4.89h1.962a2.444 2.444 0 0 0 0-4.89h-1.962zm-1.992 6.643h8.39v-8.395h-8.39v8.395z"
      />
      <path fill="#7BB835" d="M93.847 61.44h8.39v-8.395h-8.39z" />
      <path
        fill="#51A2DA"
        d="M89.39 58.636a1.38 1.38 0 0 1-1.383-1.377c0-.76.62-1.376 1.384-1.376a1.38 1.38 0 0 1 1.384 1.376c0 .76-.62 1.377-1.384 1.377zm0-3.893a2.523 2.523 0 0 0-2.53 2.516 2.523 2.523 0 0 0 2.53 2.517 2.523 2.523 0 0 0 2.531-2.517 2.523 2.523 0 0 0-2.53-2.516zm-4.185 6.698h8.39v-8.395h-8.39v8.395z"
      />
      <path fill="#53A2D9" d="M85.205 61.44h8.39v-8.395h-8.39z" />
      <path
        fill="#51A2DA"
        d="M81.882 54.798l-1.124 3.17-1.124-3.17h-1.446v4.89h1.149v-2.29l.811 2.29h1.22l.811-2.29v2.29h1.15v-4.89h-1.447zm-5.32 6.643h8.391v-8.395h-8.39v8.395z"
      />
      <path
        fill="#53A2D9"
        d="M76.563 61.44h8.39v-8.395h-8.39zM380.493 79.555h8.39V71.16h-8.39zM369.045 79.555h8.39V71.16h-8.39z"
      />
    </g>
  </Svg>
)
